/* mootlu-prefetch.js — snappy same-origin navigation.
 *
 * Prefetches product/collection page HTML on intent (hover/touch/focus) and for
 * links visible in the viewport, so the next document is warm in the HTTP cache
 * before the user taps. Vanilla, dependency-free, respects data-saver.
 */
(function () {
  'use strict';

  // Honor Save-Data and reduced-data preferences — never burn mobile data.
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (conn && (conn.saveData === true || /(^|-)2g$/.test(conn.effectiveType || ''))) return;
  try {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-data: reduce)').matches) return;
  } catch (e) { /* older browsers: ignore */ }

  var prefetched = new Set();
  var MAX = 40; // cap prefetch count per page
  var supportsPrefetch = (function () {
    var l = document.createElement('link');
    return l.relList && l.relList.supports && l.relList.supports('prefetch');
  })();

  function eligible(a) {
    if (!a || !a.href || a.origin !== location.origin) return false;
    if (a.hasAttribute('download') || a.target === '_blank') return false;
    if (a.dataset.noPrefetch != null) return false;
    var p = a.pathname || '';
    // Only content pages that benefit; skip cart/account/checkout/admin.
    if (!/\/(products|collections|pages|blogs)\//.test(p)) return false;
    if (/\/(cart|account|checkout)(\/|$)/.test(p)) return false;
    var url = a.href.split('#')[0];
    if (url === location.href.split('#')[0]) return false;
    return true;
  }

  function prefetch(url) {
    if (!url || prefetched.has(url) || prefetched.size >= MAX) return;
    prefetched.add(url);
    if (supportsPrefetch) {
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = url;
      link.as = 'document';
      document.head.appendChild(link);
    } else {
      // Safari fallback: low-priority fetch warms the HTTP cache.
      try {
        fetch(url, { credentials: 'include', priority: 'low', mode: 'no-cors' });
      } catch (e) {
        var img = new Image();
        img.src = url;
      }
    }
  }

  function onIntent(e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (eligible(a)) prefetch(a.href.split('#')[0]);
  }

  document.addEventListener('mouseover', onIntent, { passive: true });
  document.addEventListener('touchstart', onIntent, { passive: true });
  document.addEventListener('focusin', onIntent, { passive: true });

  // Warm visible links once the page is idle, throttled via IntersectionObserver.
  function warmVisible() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var a = entry.target;
        io.unobserve(a);
        if (eligible(a)) prefetch(a.href.split('#')[0]);
      });
    }, { rootMargin: '200px' });
    document.querySelectorAll('a[href]').forEach(function (a) {
      if (eligible(a)) io.observe(a);
    });
  }

  function schedule(fn) {
    if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 3000 });
    else setTimeout(fn, 1500);
  }

  if (document.readyState === 'complete') schedule(warmVisible);
  else window.addEventListener('load', function () { schedule(warmVisible); });
})();
